import React from 'react';
import Button from '@atlaskit/button/new';
export const ExtraButton = ({
  extraButtonOnClick,
  extraButtonAppearance,
  isExtraButtonDisabled,
  isSubmissionLoading,
  extraButtonText,
  testId
}) => {
  return /*#__PURE__*/React.createElement(Button, {
    testId: `${testId}-footer-extra-button`,
    onClick: extraButtonOnClick,
    appearance: extraButtonAppearance,
    isDisabled: isExtraButtonDisabled || isSubmissionLoading
  }, extraButtonText);
};